import React from 'react';
import { Link } from 'react-router-dom';

export default class JourneyContinueBox extends React.Component {
  scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  render() {
    return (
      <div className="JourneyContinueBox row">
        <div className="col-xs-16">
          <span>Next</span>
          <Link onClick={() => this.scrollToTop()} className="next-page" to={this.props.nextPageHref}>{this.props.nextPage}</Link>
        </div>
      </div>
    );
  }

};
